import { createFileRoute } from '@tanstack/react-router'

import { CoveragePage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights/coverage',
)({
  component: () => <CoveragePage slug={Route.useParams().slug} />,
})
